import { baseApi, base_url } from "./baseApi";

export const AccountDashboardApi = async (uId:any) => {
    const data = await baseApi({ url: `/client.json`, method: "GET"  })
    return { data };
}



// export const AddCheckListApi = async (postData:any) => {
//     const data = await baseApi({ url: `${base_url}checklist/create`, method: "POST" , token:true , body:JSON.stringify(postData) })
//     return { data };
// }
